export const ROUTE_PATHS = {
  home: '/',
  auctions: '/auctions',
  liveAuctions: '/live-auctions',
  shop: '/shop',
  dashboard: '/dashboard',
  admin: '/admin',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
}

export const AUTH_ROUTES = new Set([
  ROUTE_PATHS.login,
  ROUTE_PATHS.register,
  ROUTE_PATHS.forgotPassword,
  ROUTE_PATHS.resetPassword,
])

export const USER_DASHBOARD_SECTIONS = new Set([
  'overview',
  'auctions',
  'watchlist',
  'shop',
  'vault',
  'bundle',
  'orders',
  'consignments',
  'payments',
  'profile',
  'alerts',
  'settings',
])

export const ADMIN_DASHBOARD_SECTIONS = new Set([
  'overview',
  'auctions',
  'shop',
  'orders',
  'users',
  'consignments',
  'content',
  'notifications',
  'risk',
  'settings',
])

export function normalizeRoute(value) {
  const rawValue = value ?? `${window.location.pathname}${window.location.search}`
  const withoutOrigin = rawValue.replace(/^https?:\/\/[^/]+/i, '')
  const withoutHash = withoutOrigin.replace(/^#/, '')
  const path = withoutHash.split('?')[0].split('#')[0]

  if (!path || path === '/') {
    return ROUTE_PATHS.home
  }

  return path.startsWith('/') ? path : `/${path}`
}

export function navigateTo(path) {
  const nextPath = normalizeRoute(path)

  if (window.location.pathname === nextPath) {
    window.dispatchEvent(new PopStateEvent('popstate'))
    return
  }

  window.history.pushState({}, '', nextPath)
  window.dispatchEvent(new PopStateEvent('popstate'))
}

export function isAuctionDetailRoute(route) {
  return /^\/auctions\/[^/]+$/.test(route)
}

export function isShopDetailRoute(route) {
  return /^\/shop\/[^/]+$/.test(route)
}

export function isMarketplaceRoute(route) {
  return route === ROUTE_PATHS.auctions
    || route === ROUTE_PATHS.liveAuctions
    || route === ROUTE_PATHS.shop
    || isAuctionDetailRoute(route)
    || isShopDetailRoute(route)
}

export function isUserDashboardRoute(route) {
  return route === ROUTE_PATHS.dashboard || route.startsWith(`${ROUTE_PATHS.dashboard}/`)
}

export function isAdminDashboardRoute(route) {
  return route === ROUTE_PATHS.admin || route.startsWith(`${ROUTE_PATHS.admin}/`)
}

export function getDashboardSection(route, basePath, allowedSections) {
  if (route === basePath) return 'overview'

  const prefix = `${basePath}/`
  if (!route.startsWith(prefix)) return 'overview'

  const section = route.slice(prefix.length).split('/')[0]
  return allowedSections.has(section) ? section : 'overview'
}

export function dashboardRoute(basePath, section) {
  return section && section !== 'overview' ? `${basePath}/${section}` : basePath
}

export function shouldHidePublicHeader(route) {
  return AUTH_ROUTES.has(route) || isUserDashboardRoute(route) || isAdminDashboardRoute(route)
}

export function getPrimaryNavPath(route) {
  if (route === ROUTE_PATHS.auctions) {
    return ROUTE_PATHS.liveAuctions
  }

  if (isAuctionDetailRoute(route)) {
    return ROUTE_PATHS.liveAuctions
  }

  if (isShopDetailRoute(route)) {
    return ROUTE_PATHS.shop
  }

  return route
}
